module.exports = __webpack_public_path__ + "img/grub.56dcfe4e.png";